var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgRefreshBtn = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 13,
    height: 13,
    viewBox: "0 0 13 13",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0.30216 1.75096e-07H1.49603C1.66291 -0.000177559 1.79837 0.134977 1.79855 0.30192C1.79855 0.30682 1.79845 0.311721 1.79822 0.316621L1.69748 2.40127C2.88284 1.00405 4.62287 0.199494 6.45484 0.2015C9.8962 0.201526 12.7025 3.01085 12.6999 6.45321C12.6974 9.90107 9.90225 12.6953 6.45484 12.6953C4.90823 12.6974 3.4163 12.1235 2.27012 11.0855C2.14576 10.9741 2.13517 10.783 2.24648 10.6587C2.25022 10.6545 2.25407 10.6504 2.25803 10.6464L3.11421 9.78999C3.16838 9.73581 3.24113 9.70424 3.31771 9.70166C3.3943 9.69909 3.469 9.72571 3.52668 9.77613C5.36439 11.3934 8.16487 11.2143 9.78172 9.37607C11.3986 7.53782 11.2195 4.73655 9.3818 3.11924C7.54409 1.50193 4.74362 1.68104 3.12676 3.51929C3.00003 3.66339 2.88279 3.81556 2.77576 3.97483L5.33247 3.85216C5.49917 3.84424 5.64075 3.97297 5.64867 4.13974C5.6489 4.14464 5.64903 4.14954 5.649 4.15444V5.34866C5.649 5.5156 5.51372 5.65094 5.34682 5.65094H0.302135C0.135231 5.65094 -4.86374e-05 5.5156 -4.86374e-05 5.34866V0.302276C-2.38419e-05 0.135332 0.135257 1.75096e-07 0.30216 1.75096e-07Z",
    fill: "#949495"
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgRefreshBtn);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/RefreshBtn.6efb21ee9358bcd339677432e37ab204.svg";